import { NonAuthorizedContentWithImageLayout } from '@/bo-kit/components/NonAuthorizedContentWithImageLayout';
import { useTranslation } from '@/ui-kit/hooks/useTranslation';
import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { ImageSlider } from '@/bo-kit/components/ImageSlider';
import { useStyles } from '@/ui-kit/theme/styles';
import { SignUpPageForm } from './components/Form/SignUpPageForm';

export const SignUpPageResponsive: FC<{ implementation?: 'css' | 'js' }> = ({ implementation }) => {
    const classes = useStyles();
    const { t } = useTranslation('bo-kit__common');
    return (
        <NonAuthorizedContentWithImageLayout
            title={t('Sign Up')}
            implementation={implementation}
            content={
                <Stack spacing={4}>
                    <Typography variant='h1' className={classes.pageTitle}>
                        {t('Sign Up')}
                    </Typography>
                    <SignUpPageForm />
                </Stack>
            }
            image={<ImageSlider />}
        />
    );
};

// ADHOC: support lazy import
export default SignUpPageResponsive;
